import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectsHttpService } from './projects-http.service';
import { ProjectStatusesLabels, ProjectStatusesColors } from './projects.constants';
import { IProject } from './projects.interface';
import { ProjectsModalComponent } from './projects-modal/projects-modal.component';
import { ProjectsDetailComponent } from './projects-detail/projects-detail.component';
import { IFilter } from '../../../shared/interfaces/filter.interface';
import { Broadcaster } from '../../../shared/components/broadcaster.component';
import { DialogService } from '../../../shared/services/dialog/dialog.service';
import { AuthService } from '../../../shared/services/auth.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { AlertService } from '../../../shared/services/alert.service';
import { IConfirmationDialogOptions } from '../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';

let self: any;

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.css']
})
export class ProjectsComponent implements OnInit {

  loading: boolean = false;
  thereAreMore: boolean = false;
  filter: IFilter = {
    filters: {},
    sort: '-createdAt', 
    skip: 0,
    limit: 20
  };
  filtered = false;
  scrollSubscription!: Subscription;
  selection: any = { all: false };
  isDev!: boolean;
  projects: any;
  curr!: string;
  projectStatuses = ProjectStatusesLabels;
  projectStatusesKeys = Object.keys(ProjectStatusesLabels);
  projectStatusColors = ProjectStatusesColors;
  querySubscription!: Subscription;

  constructor(
    private _ProjectsService: ProjectsHttpService,
    private _broadcaster: Broadcaster,
    private _dialogService: DialogService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    private router: Router,
    private _route: ActivatedRoute,
    private _AuthService: AuthService,
    private _UtilService: UtilsService,
    private alertService: AlertService,
  ) {
    self = this;
    this.registerStringBroadcast();
    // this.registerQueryParamChanges();
  }

  ngOnInit() {
    this.isDev = this._AuthService.isRole('dev');
    this.filter.company = this._AuthService.companyId();
    this.getProjects(true);
  }

  lazySearchTmp: number = 0;
  lazySearch() {
    let tmp = new Date().getTime();
    this.lazySearchTmp = tmp;
    setTimeout(() => {
      if (tmp == this.lazySearchTmp) {
        this.getProjects(true);
      }
    }, 1000);
  }


  getProjects(reset?: boolean) {
    this.loading = true;
    this.thereAreMore = false;
    if (reset) {
      window.scroll(0, 0);
      this.filter.skip = 0;
      this.projects = [];
      this.clearSelection();
    }
    this._ProjectsService.getProjects(this.filter).subscribe((projects: any) => {
      this.projects = _.concat(this.projects, projects);
      this.thereAreMore = projects.length >= self.filter.limit;
      this.loading = false;
    })
  }

  // registerQueryParamChanges() {
  //   this.querySubscription = this._route.queryParams.subscribe(params => {
  //     if (params.action && parseInt(params.tp || '0') > (new Date().getTime() - (10 * 1000)) && (params.action == 'NEW'))
  //       setTimeout(() => this.openNewQuotesModal());
  //   })
  // }

  loadMore() {
    if (this.thereAreMore && !this.loading) {
      self.filter.skip += self.filter.limit;
      this.getProjects();
    }
  }

  registerStringBroadcast() {
    this.scrollSubscription = this._broadcaster.on<string>('FinishScrollDown')
      .subscribe(() => {
        this.loadMore();
      });
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
  }

  openNewProjectsModal() {
    this.openProjectsModal({});
  }

  openProjectsModal(project: any) {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '900px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(ProjectsModalComponent, config);
    self.dialogRef.componentInstance.project = project;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getProjects(true);
    });
  }

  openProjectDetailModal(project: any) {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '1330px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(ProjectsDetailComponent, config);
    self.dialogRef.componentInstance.project = project;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getProjects(true);
    });
  }


  openDeleteQuoteConfirm(project: IProject, hardDelete: boolean = false) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Eliminar Proyecto",
      message: "¿Esta seguro que desea eliminar el proyecto "+project.serieAndNumber+"?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._ProjectsService.deleteProject(project, hardDelete).subscribe(() => {
            if (hardDelete) this.getProjects(true);
            else {
              project.isDeleted = true;
              this.getProjects(true);
            }
          })
        }
      });
  }

  openRestoreQuoteConfirm(project: IProject) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Restaurar Proyecto",
      message: "¿Esta seguro que desea restaurar el proyecto "+ project.serieAndNumber+"?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._ProjectsService.restoreProject(project).subscribe(() => {
            project.isDeleted = false;
            this.getProjects(true);
          })
        }
      });
  }

  openFilter() {
    console.log('openFilter');
  }

  clearFilter() {
    this.filter.filters = { isDeleted: false };
    this.getProjects(true);
  }

  clearSelection() {
    this.selection = { all: false }
  }

  checkSomeSelected() {
    this.selection.some = Object.keys(this.selection)
      .filter(el => el !== 'all' && el !== 'some')
      .filter(el => this.selection[el])
      .length > 0;
  }
  
  toggleSelection(_id?: string) {
    if (_id) {
      // Modificar la selección de un elemento individual
      this.selection[_id] = !this.selection[_id];
  
      // Verificar si todos los elementos están seleccionados
      const allSelected = this.projects.every((project: IProject) => {
        const id = project._id || '';
        return this.selection[id];
      });
  
      // Actualizar "seleccionar todos" en base a los elementos seleccionados
      this.selection.all = allSelected;
    } else {
      // Seleccionar o deseleccionar todos
      const newValue = !this.selection.all;
      this.selection = { all: newValue };
  
      // Aplicar el nuevo estado a todos los elementos
      this.projects.forEach((project: IProject) => {
        const id = project._id || '';
        this.selection[id] = newValue;
      });
    }
  
    // Actualizar si hay alguna selección
    this.checkSomeSelected();
  }
  

  openNewTaskModal() {
    const status: string = 'QUOTED';
    this.router.navigate(['/admin', this._AuthService.companyIndex(), 'tasks'], { queryParams: { status: status, tp: new Date().getTime() } });
  }
}